import type { RouteRecordRaw } from 'vue-router'
import { modules as adminModules } from './admin'
import { modules as clientMoules } from './client'
import { Roles } from 'src/common/types'

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'admin',
    component: () => import('src/layouts/MainLayout.vue'),
    children: adminModules,
  },
  {
    path: '/kiosk',
    name: 'admin.kiosk',
    component: () => import('layouts/KioskLayout.vue'),
    children: [],
    meta: {
      roles: [Roles.OrgAdmin, Roles.CenterAdmin, Roles.SuperAdmin],
      supportedPlatforms: ['desktop', 'mobile', 'native'],
    },
  },
  {
    path: '/client',
    component: () => import('src/client/layouts/ClientLayout.vue'),
    children: clientMoules,
  },
  {
    path: '/',
    component: () => import('layouts/BlankLayout.vue'),
    children: [
      {
        name: 'admin.login',
        path: 'login',
        component: () => import('pages/Login.vue'),
      },
      {
        path: 'welcome',
        name: 'welcome',
        component: () => import('pages/Welcome.vue'),
      },
      {
        name: 'client.login',
        path: '/client/login',
        component: () => import('src/client/pages/ClientLogin.vue'),
      },
      {
        name: 'client.password.reset',
        path: '/client/:orgTenent/:centerTenent/reset-password',
        component: () => import('src/client/pages/ClientPasswordReset.vue'),
      },
      {
        name: 'client.password.change',
        path: '/client/change-password',
        component: () => import('src/client/pages/ClientChangePassword.vue'),
        meta: { requiresAuth: true },
      },
      {
        name: 'client.agreement',
        path: '/client/agreement',
        component: () => import('src/client/pages/ClientTermsAgreement.vue'),
        meta: { requiresAuth: true },
      },
      {
        name: 'client.pending.authorization',
        path: '/client/authorization/pending',
        component: () =>
          import('src/client/pages/ClientPendingAuthorization.vue'),
        meta: { requiresAuth: true, roles: [Roles.Client] },
      },
      {
        name: 'client.account.issue',
        path: '/client/account/issue',
        component: () => import('src/client/pages/ClientAccountIssue.vue'),
        meta: { requiresAuth: true, roles: [Roles.Client] },
      },
    ],
  },
  {
    name: 'client.onboarding',
    path: '/client/onboarding',
    component: () => import('src/client/pages/OnboardingWizard.vue'),
    meta: {
      roles: [Roles.Client],
      supportedPlatforms: ['desktop', 'mobile', 'native'],
      excludeEnv: [],
      requiresOnboarding: false, // Don't redirect to onboarding from onboarding!
    },
  },
  {
    name: 'admin.password.reset',
    path: '/reset-password',
    component: () => import('pages/StaffPasswordReset.vue'),
  },

  {
    name: 'callback.quickbooks',
    path: '/callback/QuickBooks',
    component: () => import('pages/Callback.vue'),
  },
  {
    name: 'callback.stripe',
    path: '/callback/:id',
    component: () => import('pages/Callback.vue'),
  },

  {
    path: '/forms',
    component: () => import('layouts/BlankLayout.vue'),
    children: [
      {
        path: 'registrationForm',
        component: () =>
          import('components/communicate/marketing/publicFormsV2/PublicRegistrationWizardV2.vue'),
      },
      {
        path: 'interestForm',
        component: () =>
          import('components/communicate/marketing/publicFormsV2/PublicInterestForm.vue'),
      },
      {
        path: 'tourForm',
        component: () =>
          import('components/communicate/marketing/publicFormsV2/PublicTourForm.vue'),
      },
    ],
  },
  {
    path: '/setup/stripe_connect',
    name: 'stripeConnect',
    component: () => import('components/setup/Center/StripeAccountConnect.vue'),
    meta: {
      roles: [Roles.OrgAdmin, Roles.CenterAdmin, Roles.SuperAdmin],
      supportedPlatforms: ['desktop', 'mobile', 'native'],
    },
  },
  {
    path: '/outdatedVersion',
    name: 'outdatedVersion',
    component: () => import('pages/OutdatedVersion.vue'),
    meta: {
      roles: [
        Roles.OrgAdmin,
        Roles.CenterAdmin,
        Roles.SuperAdmin,
        Roles.OfficeStaff,
        Roles.RoomStaff,
        Roles.Client,
      ],
      supportedPlatforms: ['desktop', 'mobile', 'native'],
    },
  },
  {
    path: '/deposit',
    name: 'depositPayment',
    component: () => import('pages/DepositPayment.vue'),
    meta: {
      roles: [
        Roles.OrgAdmin,
        Roles.CenterAdmin,
        Roles.SuperAdmin,
        Roles.OfficeStaff,
        Roles.RoomStaff,
        Roles.Client,
      ],
      supportedPlatforms: ['desktop', 'mobile', 'native'],
    },
  },
  {
    path: '/deposit-complete',
    name: ' depositPaymentComplete',
    component: () => import('pages/DepositPaymentComplete.vue'),
    meta: {
      roles: [
        Roles.OrgAdmin,
        Roles.CenterAdmin,
        Roles.SuperAdmin,
        Roles.OfficeStaff,
        Roles.RoomStaff,
        Roles.Client,
      ],
      supportedPlatforms: ['desktop', 'mobile', 'native'],
    },
  },
  {
    name: 'error.404',
    path: '/404',
    component: () => import('pages/Error404.vue'),
    meta: {
      roles: [
        Roles.OrgAdmin,
        Roles.CenterAdmin,
        Roles.SuperAdmin,
        Roles.OfficeStaff,
        Roles.RoomStaff,
        Roles.Client,
      ],
      supportedPlatforms: ['desktop', 'mobile', 'native'],
    },
  },
  {
    path: '/:catchAll(.*)*',
    component: () => import('pages/Error404.vue'),
    meta: {
      roles: [
        Roles.OrgAdmin,
        Roles.CenterAdmin,
        Roles.SuperAdmin,
        Roles.OfficeStaff,
        Roles.RoomStaff,
        Roles.Client,
      ],
      supportedPlatforms: ['desktop', 'mobile', 'native'],
    },
  },
]

export default routes
